import type { FC } from 'react'
import { P3 } from '../../compass-ui/Typography/Typography'
import type { OfferTermDisplay } from '../../types'

interface OfferTermRowProps {
  offerTerm: OfferTermDisplay
  variant?: 'default' | 'inPage'
}

const OfferTermRow: FC<OfferTermRowProps> = ({ offerTerm, variant = 'default' }) => {
  const { id, value, subValue, title: offerTermTitle } = offerTerm

  const titleColor = variant === 'inPage' ? 'text-ink-600' : 'text-green-300'
  const valueColor = variant === 'inPage' ? 'text-ink-800' : 'text-white'
  const subValueColor = variant === 'inPage' ? 'text-ink-600' : 'text-green-300'
  const borderColor = variant === 'inPage' ? 'border-ink-400' : 'border-green-700'

  return (
    <div data-testid={id} className={`flex flex-row justify-between border-b-1 ${borderColor}`}>
      <P3 color={titleColor}>{offerTermTitle}</P3>
      <div className="flex flex-col items-end">
        {value && (
          <P3 color={valueColor} className="text-right">
            <b>{value}</b>
          </P3>
        )}
        {subValue && <span className={`${subValueColor} text-xs md:text-sm`}>{subValue}</span>}
      </div>
    </div>
  )
}

export default OfferTermRow
